import { useEffect, useState } from "react";
import {
  Dialog,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
  Fade,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const BannerPopup = ({desktopImage, mobileImage, storageKey = "banner-popup-visto", onClick,}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const bannerVisto = sessionStorage.getItem(storageKey);

    if (!bannerVisto) {
      setOpen(true);
      sessionStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleClose = () => {
    setOpen(false);
  };

  const image = isMobile ? mobileImage : desktopImage;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
      transitionDuration={500}
      maxWidth="md"
      PaperProps={{
        sx: {
          position: "relative",
          overflow: "hidden",
          borderRadius: { xs: 2, sm: 3},
          backgroundColor: "transparent",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.35)",
          margin: { xs: 2, sm: 3},
        },
      }}
    >
      {/* Botón cerrar */}
      <IconButton
        onClick={handleClose}
        aria-label="Cerrar banner"
        sx={{
          position: "absolute",
          top: { xs: 6, sm: 10},
          right: { xs: 6, sm: 10},
          zIndex: 2,
          width: { xs: 34, sm: 40},
          height: { xs: 34, sm: 40},
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          backdropFilter: "blur(4px)",
          transition: "all 0.25s ease",

          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            transform: "scale(1.08)",
          },
        }}
      >
        <CloseIcon
          sx={{ fontSize: { xs: 22, sm: 26},}}
        />
      </IconButton>

      {/* Banner */}
      <Box
        component="img"
        src={image}
        alt="Pre-registro en línea"
        onClick={onClick}
        sx={{
          display: "block",
          width: "100%",
          height: "auto",
          maxWidth: { xs: "320px", sm: "800px",},
          cursor: onClick ? "pointer" : "default",
          transition: "transform 0.3s ease",
          "&:hover": onClick
            ? {
                transform: "scale(1.01)",
              }
            : {},
        }}
      />
    </Dialog>
  );
};

export default BannerPopup;
